import ETBaseDataModel from '@/eventTracking/model/baseData'

const initialState = {
    eTBaseDataModel: []
}

export type iEventTrackingState = Readonly<typeof initialState>;

export const ACTION_TYPES = {
    SET_EVENTTRACKING_DATA: "SET_EVENTTRACKING_DATA"
};
export default (state: iEventTrackingState = initialState, { type, payload }): iEventTrackingState => {
    switch (type) {
        case ACTION_TYPES.SET_EVENTTRACKING_DATA: {
        return {
            ...state,
            eTBaseDataModel:payload,
        }
    }
        default:
        return state;
    }
};
/**
 * 设置埋点数据
*/
export const setEventTrackingData = (payload) => ({
    type: ACTION_TYPES.SET_EVENTTRACKING_DATA,
    payload
});